'use client';

import { AD_PLACEMENTS } from './adPlacements';
import { BannerAdSlot } from './BannerAdSlot';

export const SearchTopAdBanner = () => (
  <BannerAdSlot {...AD_PLACEMENTS.searchTopBanner} />
);
